import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

export default function getWorkoutSectionsWorkoutUtil (workout) {
  return getValueReduxUtil(workout, WORKOUT_KEY.WORKOUT_SECTIONS) || []
}
